import { Layout } from '@/components/layout/Layout';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { useEffect, useState } from 'react';

export default function Cgv() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(new URL('@/content/cgv.md', import.meta.url))
      .then((res) => res.text())
      .then(setContent)
      .catch(console.error);
  }, []);

  return (
    <Layout>
      <section className="pt-32 pb-24">
        <div className="section-container max-w-5xl">

          <h1 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-2">
            Conditions Générales de Vente
          </h1>

          <p className="text-sm text-foreground mb-12">
            Version en vigueur à compter du 27/01/2026
          </p>

          {content && (
            <ReactMarkdown
              remarkPlugins={[remarkGfm, remarkBreaks]}
              components={{
                h1: ({ children }) => (
                  <h2 className="mt-10 mb-4 text-2xl font-bold text-foreground">
                    {children}
                  </h2>
                ),
                h2: ({ children }) => (
                  <h3 className="mt-8 mb-3 text-xl font-semibold text-foreground">
                    {children}
                  </h3>
                ),
                p: ({ children }) => (
                  <p className="mb-4 leading-relaxed text-foreground">
                    {children}
                  </p>
                ),
                ul: ({ children }) => (
                  <ul className="mb-4 ml-6 list-disc space-y-1">
                    {children}
                  </ul>
                ),
                li: ({ children }) => (
                  <li className="text-foreground">
                    {children}
                  </li>
                ),
                strong: ({ children }) => (
                  <strong className="text-foreground font-semibold">
                    {children}
                  </strong>
                ),
                blockquote: ({ children }) => (
                  <blockquote className="my-4 border-l-4 border-primary pl-4 italic text-foreground">
                    {children}
                  </blockquote>
                ),
              }}
            >
              {content}
            </ReactMarkdown>
          )}

        </div>
      </section>
    </Layout>
  );
}
